import React, { memo, useContext, useMemo, useState } from 'react'
import { MenuActionItem } from 'src/interfaces/ui'
import { ActionMenu } from 'src/components/shared/ActionMenu'
import { SendMajor } from '@shopify/polaris-icons'
import tw from 'twin.macro'
import { createAsyncAction } from 'src/utils/reduxUtils'
import { useDispatch } from 'react-redux'
import { ResendTeamMemberInvite } from 'src/constants/actionTypes'
import { showToast } from 'src/utils/toast'
import { handleApiError } from 'src/utils/errorHandlers'
import { TeamMemberInvitesTableContext } from './TeamMemberInvitesTable.context'
import CircularProgress from '@mui/material/CircularProgress'

const TeamMemberInviteActionMenuComponent = () => {
  const dispatch = useDispatch()

  const {
    teamMemberInviteToAction,
    actionAnchor,
    closeTeamMemberInviteItemAction,
    refreshTeamMemberInvites,
  } = useContext(TeamMemberInvitesTableContext)

  const isOpen = Boolean(actionAnchor)
  const [isLoading, setIsLoading] = useState(false)

  const actionItems: MenuActionItem[] = useMemo(() => {
    const res: MenuActionItem[] = []

    res.push({
      label: 'Resend an invite',
      icon: isLoading ? <CircularProgress size={20} /> : <SendMajor width={20} height={20} />,
      dataTestId: teamMemberInviteToAction
        ? `my-team-invites-row-${teamMemberInviteToAction.id}-resend-invite`
        : undefined,
      onClick: async () => {
        if (!teamMemberInviteToAction) {
          return
        }

        setIsLoading(true)

        try {
          await createAsyncAction(
            dispatch,
            ResendTeamMemberInvite.request({
              teamMemberInviteId: teamMemberInviteToAction.id,
            }),
          )

          showToast('Invite is sent', { variant: 'success' })
          refreshTeamMemberInvites()
        } catch (err) {
          handleApiError(err)
        } finally {
          setIsLoading(false)
          closeTeamMemberInviteItemAction()
        }
      },
    })

    return res
  }, [teamMemberInviteToAction, isLoading])

  return (
    <ActionMenu
      anchorEl={actionAnchor}
      itemClassName={tw`min-w-[208px]`}
      isOpen={isOpen}
      items={actionItems}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      onClose={closeTeamMemberInviteItemAction}
    />
  )
}

export const TeamMemberInviteActionMenu = memo(TeamMemberInviteActionMenuComponent)
